module.exports = __webpack_public_path__ + "img/hti.fb289ca0.svg";